const list = {};
const write = {};
const page = {};
const excelUpload = {};
const excelUploadBulk = {};
const aiVoiceSchema = {};

// Write.vue --> key : 폴더명_write
const filesWriteVue = require.context(".", true, /Write\.vue$/);
filesWriteVue.keys().forEach((key) => {
  write[key.toLowerCase().replace(/(\.\/|\.vue)/g, "").replace("/", "_")] = filesWriteVue(key).default;
});

// List.js --> key : 폴더명_list
const filesListVue = require.context(".", true, /List\.js$/);
filesListVue.keys().forEach((key) => {
  list[key.toLowerCase().replace(/(\.\/|\.js)/g, "").replace("/", "_")] = filesListVue(key).default;
});

// Page.vue --> key : 폴더명_page
const filesPageVue = require.context(".", true, /Page\.vue$/);
filesPageVue.keys().forEach((key) => {
  page[key.toLowerCase().replace(/(\.\/|\.vue)/g, "").replace("/", "_")] = filesPageVue(key).default;
});

// ExcelUpload.vue --> key : 폴더명_excelupload
const filesExcelUploadVue = require.context(".", true, /ExcelUpload\.vue$/);
filesExcelUploadVue.keys().forEach((key) => {
  excelUpload[key.toLowerCase().replace(/(\.\/|\.vue)/g, "").replace("/", "_")] = filesExcelUploadVue(key).default;
});

// ExcelUploadBulk.vue --> key : 폴더명_exceluploadbulk
const filesExcelUploadBulkVue = require.context(".", true, /ExcelUploadBulk\.vue$/);
filesExcelUploadBulkVue.keys().forEach((key) => {
  excelUploadBulk[key.toLowerCase().replace(/(\.\/|\.vue)/g, "").replace("/", "_")] = filesExcelUploadBulkVue(key).default;
});

// ai-voice-schema.js --> key : 폴더명(게시판번호)
// AI 음성 작성용 의미 스키마. Write.vue 와 같은 폴더에 두면 자동으로 등록된다.
const filesAiVoiceSchema = require.context(".", true, /ai-voice-schema\.js$/);
filesAiVoiceSchema.keys().forEach((key) => {
  // "./801/ai-voice-schema.js" --> "801"
  const boardId = key.replace("./", "").split("/")[0];
  aiVoiceSchema[boardId] = filesAiVoiceSchema(key).default;
});

export default {write, list, page, excelUpload, excelUploadBulk, aiVoiceSchema};
